import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  isAutoFocused?: boolean;
};

export const ChatSearchField = ({
  value,
  onChange,
  placeholder,
  isAutoFocused = false,
}: Props) => (
  <TextField
    size="small"
    fullWidth
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    autoFocus={isAutoFocused}
    slotProps={{
      input: {
        sx: { borderRadius: "999px", minHeight: "44px" },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={() => onChange("")} edge="end">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      },
    }}
  />
);
